import { useState, useEffect } from 'react';
import { Avatar, Grid, ListItemAvatar, Stack, Typography, } from '@mui/material';
import { Button, Alert, Chip } from '@mui/material';
import { List, ListItem, ListItemText, ListItemButton, ListItemIcon } from '@mui/material';
import { Dialog, DialogActions, DialogContent } from '@mui/material';

import { pb } from '../utilities/pocketbase';
import { format } from "date-fns";

import FingerprintJS from '@fingerprintjs/fingerprintjs';

import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import TaskIcon from '@mui/icons-material/Task';
import PendingIcon from '@mui/icons-material/Pending';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import CRRaoAIMSCSLogo from '../crrao_aimscs_logo-min.png'

export default function Approve() {
    const [userData, setUserData] = useState({})
    const [exams, setExams] = useState([])
    const [approvals, setApprovals] = useState([])
    const [error, setError] = useState("")
    const [refresh, setRefresh] = useState(false)
    const [visitorId, setVisitorId] = useState("")

    useEffect(() => {
        window.document.title = 'Approve Exams'
        pb.collection('exams').getFullList({
            sort: 'starts',
        }).then(_exams => {
            setExams(_exams)
            console.log("exams: ", _exams)
        }).catch(error => {
            console.log("exams error: ", error)
            // setError(error?.message)
        })

        return () => { window.document.title = process.env.REACT_APP_NAME }
    }, [])

    useEffect(() => {
        if (pb?.authStore?.model?.id) {
            setError("")
            pb.collection('supervisors').getOne(`${pb?.authStore?.model?.id}`).then(supervisor => {
                setUserData(supervisor)
                pb.collection('approvals').getFullList(`supervisor = ${pb?.authStore?.model?.id}`, {
                    expand: "exam"
                }).then(approvals => {
                    console.log("approvals: ", approvals)
                    setApprovals(approvals)
                }).catch(error => {
                    console.log("approvals error:", error)
                    setError(error?.message)
                })
            }).catch(error => {
                setError(error?.message)
            })

            FingerprintJS.load().then((fp) => fp.get()).then((result) => {
                setVisitorId(result?.visitorId)
                const processedData = {
                    visitorId: result?.visitorId,
                    confidence: result?.confidence?.score,
                    components: { ...result?.components, canvas: undefined }
                }
                pb.collection('fingerprints').create(processedData).then(record => {
                    console.log("fingerprint record created: ", record)
                }).catch(error => {
                    console.log("fingerprint record create error: ", error)
                })
            })
        } else {
            console.log("approvals auth error:")
        }
    }, [refresh])

    const approvedExams = approvals.filter(x => x?.exam && x).map(x => x?.exam)

    return (
        <Grid container spacing={2} justifyContent={"center"} alignItems={"center"} sx={{ py: 2 }}>
            <Grid item xs={12} sm={12} md={10} lg={7}>
                <Stack spacing={2}>
                    <Typography variant='h6' sx={{ mb: 2 }}>Exam approval dashboard</Typography>
                    <ListItem sx={{ border: 1, borderRadius: 3, borderColor: "divider", }}>
                        <ListItemAvatar>
                            <Avatar variant='rounded' sx={{ background: "transparent" }}>
                                <SupervisorAccountIcon color='warning' />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={pb?.authStore?.model?.username ?? "Unknown!"} secondary={`${pb?.authStore?.model?.email} • supervisor` ?? "unknown! • supervisor"} />
                    </ListItem>
                    <Typography variant='subtitle1' fontWeight={"bold"}>Exams available</Typography>
                    {exams?.length > 0 && <List>
                        {exams
                            .filter(x => x?.id && x?.level && x)
                            .map((exam, index) => (<ApproveExam key={exam?.id + index} userData={userData} exam={exam} approvedExams={approvedExams} setError={setError} setRefresh={setRefresh} />))}
                    </List>}
                    {error && <Alert severity='error' sx={{ justifyContent: "center", alignItems: "center", border: 1 }}>{error}</Alert>}
                </Stack>
            </Grid>

            {false && <Grid item xs={12} sm={12} md={5} lg={5}>
                <Typography variant='subtitle1' fontWeight={"bold"}>Approved exams</Typography>
                {exams?.length > 0 && approvals?.length > 0 && <List>
                    {approvals
                        .filter(x => x?.id && x?.exam && x?.supervisor && x)
                        .map((approval, index) => (<ListItem key={approval.id} sx={{ border: 1, borderRadius: 3, borderColor: "divider", mb: 1 }}>
                            <ListItemIcon>
                                <CheckCircleIcon color='success' />
                            </ListItemIcon>
                            <ListItemText secondary={`${approval?.expand?.exam?.name}`} primary={`${approval?.expand?.exam?.starts && format(new Date(approval?.expand?.exam?.starts), 'PPPpp')} to ${approval?.expand?.exam?.ends && format(new Date(approval?.expand?.exam?.ends), 'pp')}`} />
                        </ListItem>))}
                </List>}
            </Grid>}
        </Grid>
    )
}

const ApproveExam = ({ userData, exam, approvedExams, setError, setRefresh }) => {
    const [open, setOpen] = useState(false)

    const approveExam = (event, examId) => {
        setError("")
        const data = {
            exam: examId,
            supervisor: `${pb?.authStore?.model?.id}`,
            approved: true
        }
        pb.collection('approvals').getFirstListItem(`exam = "${examId}"`).then(approval => {
            console.log("already approved: ", approval)
            setError("Already Approved!")
        }).catch(error => {
            console.log("approve find error: ", error)
            pb.collection('approvals').create(data).then(approve => {
                console.log("approve created!", approve)
            }).catch(error => {
                console.log("approve create error!", error)
                setError("Approved Error!")
            }).finally(() => { setOpen(false); setRefresh(ps => !ps) })
        }).finally(() => setOpen(false))
    };

    const approved = approvedExams && approvedExams.length > 0 && approvedExams.includes(exam?.id)

    return (
        <>
            <ListItemButton key={exam.id} sx={{ border: 1, borderRadius: 3, borderColor: "divider", mb: 1 }} onClick={() => setOpen(true)} disabled={approved}>
                <ListItemAvatar>
                    <Avatar src={CRRaoAIMSCSLogo} variant="rounded" sx={{ background: "transparent" }}>
                        <TaskIcon color="info" />
                    </Avatar>
                </ListItemAvatar>
                <ListItemText secondary={`${exam?.name} • Level ${exam.level}`} primary={`${exam.starts && format(new Date(exam.starts), 'PPPpp')} to ${exam.ends && format(new Date(exam.ends), 'pp')}`} />
                <Chip
                    label={approved ? "Approved" : "Pending approval"} size='medium'
                    icon={approved ? <CheckCircleIcon color='success' /> : <PendingIcon color='info' />}
                // color={approved ? "success" : "info"}
                />
            </ListItemButton>
            <Dialog open={open} onClose={() => setOpen(false)} PaperProps={{ sx: { borderRadius: 3 } }}>
                <DialogContent>
                    <ListItem key={exam.id} >
                        <ListItemText secondary={`${exam?.name} • Level ${exam.level}`} primary={`${exam.starts && format(new Date(exam.starts), 'PPPpp')} to ${exam.ends && format(new Date(exam.ends), 'pp')}`} />
                    </ListItem>
                </DialogContent>
                <DialogActions>
                    <Button color="error" sx={{ py: 2 }} onClick={() => setOpen(false)} fullWidth>
                        Cancel
                    </Button>
                    <Button color="success" sx={{ py: 2 }} onClick={(e) => approveExam(e, exam?.id)} fullWidth>
                        Approve
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}